import { ICompileProvider, IComponentOptions } from "angular";
import * as angular from "angular";

export const LAZY_COMPILER_SERVICE = "lazyCompilerService";

export class LazyCompilerService {
    static $inject = ["$compileProvider"];
    constructor(private $compileProvider: ICompileProvider){

    }

    registerComponent(name: string, options: IComponentOptions){
        this.$compileProvider.component(name, options);
    }
}


// WEBPACK FOOTER //
// ./app/core/lazy-compiler.service.ts